<template>
    <div> 
        <div class="modal-mask" v-if="!hide">
            <div class="modal-wrapper">
                <div class="modal-container text-center">
                    <div class="container">
                        <div class="card">
                            <div class="card-header">Du bist nicht angemeldet!</div>
                            <div class="card-body" v-html="loginMessage"></div>
                            <div class="card-footer">
                                <button class="btn btn-danger" @click="onHide">Verbergen</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
export default {
  name: "warning-you-are-logged-out",
  props: ["loginMessage"],
  data: function() {
    return {
        hide: false
    };
  },
  methods: {
    onHide() {
        this.hide = true;
    }
  }
};
</script>
 

<style scoped>
.modal-mask {
  position: fixed;
  overflow: auto;

  z-index: 200;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.3);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  margin: auto;
}

.modal-container {
  margin: 0px auto;
  padding: 20px 30px;
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
